__webpack_require__.p = "/StandupShuffle/";